// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/App/Module/Home/Component/WidgetGrid/style.css
// module id = 8272
// module chunks = 2